export default "__VITE_ASSET__Dgi0IZ0I__"